import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity.ts';

import { VenuePresetDto } from './project-venue-presets.dto.schema.ts';

export class VenuePresetsMapper {
  static dtoToEntity(dto: VenuePresetDto): VenuePreset {
    return {
      id: dto.id,
      projectId: +dto.projectId,
      organisationId: +dto.organisationId,
      order: dto.order,
      presetTitle: dto.title || '',
      avgCapacity: dto.values?.avgCapacity || 0,
      accommodation: dto.values?.accommodation || [],
      equipment: dto.values?.equipment || [],
      mobility: dto.values?.mobility || [],
    };
  }

  static entityToDto(presetForm: VenuePreset): VenuePresetDto {
    return {
      id: presetForm.id,
      title: presetForm.presetTitle,
      organisationId: +presetForm.organisationId,
      order: presetForm.order,
      projectId: +presetForm.projectId,
      values: {
        avgCapacity: presetForm.avgCapacity,
        mobility: presetForm.mobility,
        accommodation: presetForm.accommodation,
        equipment: presetForm.equipment,
      },
    };
  }
}
